import Mrigu from "../assets/Testimonial/testimonialmrigu.jpeg";
import Asrani from "../assets/images-6.jpeg";
import Pranay from "../assets/Testimonial/pranayBhaiya.jpg";
import Chaitanya from "../assets/Testimonial/Bhopal.JPG";
import Armaan from "../assets/Testimonial/e131b2f1-415e-44b0-a28a-620cf5cb9dba.JPG";
import Dharuva from "../assets/Testimonial/Dharuva.JPG";
export const testimonialsData = [
  {
    image: Pranay,
    review: "Now everyone knows “Bus kahan pahunchi aur kitni der me aayegi”",
    name: "PRANAY BHAIYA",
    status: "CEO",
  },
  {
    image: Mrigu,
    review:
      "Manage your businesses efficiently making use of the analytics and reports to cut down those unnecessary spendings",
    name: "MRIGESH THAKUR",
    status: "DEVELOPER",
  },
  {
    image: Asrani,
    review: " Ensure safety of your loved ones because it’s never too late",
    name: "AMAN ASRANI",
    status: "HARE KRISHNA",
  },
  {
    image: Armaan,
    review: " Ensure safety of your loved ones because it’s never too late",
    name: "ARMAAN SHUKLA",
    status: "HARE KRISHNA",
  },
  {
    image: Dharuva,
    review:
      " Don’t waste time at the bus stops if the school bus is not on time",
    name: "DHARUVA THAKUR",
    status: "HARE KRISHNA",
  },
  {
    image: Chaitanya,
    review:
      "It has become so convenient to manage businesses leveraging the power of our innovative solutions that never existed before",
    name: "CHAITANYA BHOPAL",
    status: "HARE KRISHNA",
  },
];
